import React, { Component } from "react";

import _ from "lodash";
import * as kurentoUtils from "kurento-utils";
import { wsocket } from "WEBSOCKET/wsocket";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { isMobileOnly, isIE, isTablet, isIOS } from "react-device-detect";

import IconsPositionBar from "./IconsPositionBar";
import BitRateTile from "COMPONENTS/CommonComponents/BitRate/BitRateTile";

import {
  socketMessage,
  webRtcMessageId,
  mediaType,
  mediaStatus
} from "WEBSOCKET/constants";

import {
  COMPONENT_IN_FOCUS, OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO, USER_ROLES, FULL_SCREEN_V2_ID,
  BANDWIDTH_CUSTOM, USER_STATIC, SESSION_SUBTYPES
} from "UTILS/Constants";

import { getMessage } from "CONFIG/i18n";

import {
  getMediaConstraints, 
  getUserMediaError,
  getTurnServerOptionConfig,
  getFirstNamebyParticipantId,
  getUserNameForSelectedLanguage,
  isMobileView
} from "UTILS/Utility";

import "../Whiteboard/AnnotationBar/AnnotationBar";

import "./Styles.less";

// Assets 
import ic_minimize from "ASSETS/Images/video_menu/ic_full_screen_stop.svg";
import ic_mic_off from "ASSETS/Images/video_menu/ic_mic_off.svg";
import img_avater_agent from "ASSETS/Images/avatar/avatar_agent.svg";
import img_avater_user from "ASSETS/Images/avatar/avatar_user.svg";

export default class VideoComponent extends Component {

  constructor(props) {
    super(props);
    this.state={
      isTransform: props.isTransform
    }
    this.waitVideoRtcPeer = 0;
    this.waitAudioRtcPeer = 0;
    this.audioWatcher = 0;
    this.createTime = Date.now();
    console.debug(`VideoComponent constructor() OUT createTime=${this.createTime} uniqueId=${props.uniqueId}`)
  }

  getIdSuffix() {
    return this.props.inFullScreenV2Container ? FULL_SCREEN_V2_ID.SUFFIX : '';
  }

  playStreamInFullScreenV2 = (audioAndVideoRtcPeer, mediaElement)=> {
    if ( mediaElement ) {
      if (this.props.uniqueId === this.props.participant.uniqueId) {  // for self
        if(audioAndVideoRtcPeer.getLocalStream()) {
          mediaElement.srcObject = audioAndVideoRtcPeer.getLocalStream(); 
        } 
        if(this.props.currentStream) {
          mediaElement.srcObject = this.props.currentStream;
        }
      } else {
        mediaElement.srcObject = audioAndVideoRtcPeer.getRemoteStream();
      }
      mediaElement.play()
      .then(() => {
        console.log(`Video has been played successfully`);
      })
      .catch((error) => 
        console.error(`an error occurred while playing Video, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
    }
  }

  setWatcherInFullScreenV2 = (audioAndVideoRtcPeer) => {
    const participant = document.getElementById(this.props.participant.uniqueId + this.getIdSuffix());
    const pc = audioAndVideoRtcPeer.peerConnection;
    this.audioWatcher = setInterval(() => {
      pc.getStats(null).then((stats) => {
        stats.forEach((report) => {
          if(report.audioLevel && report.audioLevel >= 0.1) {
            participant.classList.remove("speaking");
            void participant.offsetWidth;
            participant.classList.add("speaking");
          }
        });
      });
      if(pc.connectionState == 'disconnected' ||
        pc.connectionState == 'failed' ||
        pc.connectionState == 'closed') {
        clearInterval(this.audioWatcher);
        this.audioWatcher = 0; 
      }
    }, 200);
  }

  startCallInFullScreenV2 = () => {
    if (this.props.sessionType !== SESSION_SUBTYPES.SUPPORT_CENTER) return;
    const isEnabledConnection = (rtcPeer) => {
      if ( rtcPeer &&
        rtcPeer.peerConnection &&
        rtcPeer.peerConnection.connectionState == "connected" ) {
        return true;
      }
      return false;
    }
    const videoElement = document.getElementById(this.props.participant.uniqueId + "video" + this.getIdSuffix());
    let audioAndVideoRtcPeer = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType.VIDEO];
    if (this.props.participant.mediaType === mediaType.AUDIO_VIDEO &&
      this.waitVideoRtcPeer == 0 &&
      !this.props.isPeerError(this.props.participant.uniqueId, mediaType.VIDEO )) {
      if ( isEnabledConnection(audioAndVideoRtcPeer) ) {
        this.playStreamInFullScreenV2(audioAndVideoRtcPeer, videoElement);
      } else {
        this.waitVideoRtcPeer = setInterval( () => {
          if (this.props.isPeerError(this.props.participant.uniqueId, mediaType.VIDEO )) {
            clearInterval(this.waitVideoRtcPeer);
            this.waitVideoRtcPeer = 0;
            return;
          }
          audioAndVideoRtcPeer = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType.VIDEO];
          if ( isEnabledConnection(audioAndVideoRtcPeer) ) {
            clearInterval(this.waitVideoRtcPeer);
            this.playStreamInFullScreenV2(audioAndVideoRtcPeer, videoElement);
            this.waitVideoRtcPeer = 0;
          }
        }, 500 );
      }
    }

    if ( this.props.uniqueId !== this.props.participant.uniqueId &&
      this.audioWatcher == 0 &&
      this.waitAudioRtcPeer == 0 &&
      !this.props.isPeerError(this.props.participant.uniqueId, mediaType.AUDIO )) {
      audioAndVideoRtcPeer = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType.AUDIO];
      if ( isEnabledConnection(audioAndVideoRtcPeer) ) {
        this.setWatcherInFullScreenV2(audioAndVideoRtcPeer, videoElement);
      } else {
        this.waitAudioRtcPeer = setInterval( () => {
          if (this.props.isPeerError(this.props.participant.uniqueId, mediaType.AUDIO )) {
            clearInterval(this.waitAudioRtcPeer);
            this.waitAudioRtcPeer = 0;
            return;
          }
          audioAndVideoRtcPeer = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType.AUDIO];
          if ( isEnabledConnection(audioAndVideoRtcPeer) ) {
            clearInterval(this.waitAudioRtcPeer);
            this.setWatcherInFullScreenV2(audioAndVideoRtcPeer, videoElement);
            this.waitAudioRtcPeer = 0;
          }
        }, 500);
      }
    }
  }

  async componentDidMount() {
    // let videoElement = document.getElementById(this.props.participant.uniqueId + "video");
    // if(videoElement){
    //   videoElement.onloadedmetadata = () => {
    //     if(wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] && this.props.participant.videoStatus === mediaStatus.MUTED){
    //       wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId]["VIDEO"].videoEnabled = false
    //     }
    //   }
    // }
    if (this.props.inFullScreenV2Container) {
      this.startCallInFullScreenV2();
    } else {
      setTimeout(() => {
        this.startCall();
      }, 1000);
      // need to reset screenshare top here because it takes time to load which needs top recalculation 
      this.props.setScreenShareTopMargin();

      var mediaElement = document.getElementById(this.props.uniqueId + "video");

      this.interval = setInterval(()=> {
        if(mediaElement && mediaElement.clientWidth) {
          this.props.setFlimStripOverflow();
          clearInterval(this.interval)
        }
      }, 2000)

      if(mediaElement) {
        mediaElement.oncanplay = () => {
          this.props.enableCamera(true)
          this.props.hideSpinner();
        }
  
        mediaElement.oncanplaythrough = () => {
          this.props.enableCamera(true)
          this.props.hideSpinner();
        }
      }

      // scroll to the video component when self video component is rendered
      if(this.props.uniqueId == this.props.participant.uniqueId && (isMobileOnly || (isTablet && !this.props.isLandscape))) {
        let videoComponent = document.getElementById("videoComponent");
        videoComponent && videoComponent.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    }

    if (this.state.isTransform) {
      const targetVideo = document.getElementById(this.props.uniqueId + "video" + this.getIdSuffix());
      targetVideo.style.transform = "scale(1)";
    }
  }

  startCall() {
    if (!wsocket.io) return;
    if (this.props.sessionType !== SESSION_SUBTYPES.SUPPORT_CENTER) return;
    if (this.props.uniqueId === this.props.participant.uniqueId) {  // for self
      let audioElement = document.getElementById(this.props.participant.uniqueId + "audio");
      if(!audioElement) {
        audioElement = this.getAudioElement(this.props.participant.uniqueId);
        this.createRTCPeerAndStartSharing(
          audioElement,
          getMediaConstraints({
            media:mediaType.AUDIO,
            audioDeviceId: this.props.audioDeviceId,
          }),
          this.onIceCandidateAudio,
          this.offerToReceiveAudio,
          mediaType.AUDIO
        );
      }
    } else {
      // receive only
      // control comes here when we get _NEW_WEBRTC_MEDIA i.e. when user has started sharing his media
      if (this.props.participant.mediaType === mediaType.AUDIO_VIDEO) {
        let videoElement = document.getElementById(this.props.participant.uniqueId + "video" + this.getIdSuffix());
        const videoBandwidthSettings = _.cloneDeep(this.props.videoBandwidthSettings);
        if (this.props.videoBandwidthSettings.bandwidth === BANDWIDTH_CUSTOM) {
          videoBandwidthSettings.bandwidth = this.props.videoCustomBandwidthSettings.size;
        }
        this.createRTCPeerAndStartReceiving(
          videoElement,
          getMediaConstraints({
            media: mediaType.VIDEO,
            videoBandwidthSettings,
            isLandscape: this.props.isLandscape,
          }),
          this.onIceCandidate,
          this.offerToReceiveVideo,
          mediaType.VIDEO        
        );
      }
      let audioElement = document.getElementById(this.props.participant.uniqueId + "audio");
      if(!audioElement) {
        audioElement = this.getAudioElement(this.props.participant.uniqueId);
        this.createRTCPeerAndStartReceiving(
          audioElement,
          getMediaConstraints({
            media:mediaType.AUDIO,
          }),
          this.onIceCandidateAudio,
          this.offerToReceiveAudio,
          mediaType.AUDIO
        );
      }
    }
  }

  componentDidUpdate(prevProp){
    // WebRtc再接続フラグ
    const needsRtcPeerReconnect = this.props.webRtcReconnectingParticipantId === this.props.participant.uniqueId;
    const prevNeedsRtcPeerReconnect  = prevProp.webRtcReconnectingParticipantId === this.props.participant.uniqueId;

    // audio to video promotion
    if((!_.isEqual(this.props.participant, prevProp.participant) && 
    prevProp.participant.mediaType === "AUDIO" &&
    this.props.participant.mediaType === "AUDIO_VIDEO") 
    || 
    // WebRTC reconnection: needsRtcPeerRecreation flag changed from false/undefined to true
    (!prevNeedsRtcPeerReconnect  && needsRtcPeerReconnect && 
     (this.props.participant.mediaType === "AUDIO" || 
      this.props.participant.mediaType === "AUDIO_VIDEO"))
    ||
    (this.props.primaryParticipant !== prevProp.primaryParticipant && (
      prevProp.primaryParticipant.uniqueId === this.props.participant.uniqueId || 
      this.props.primaryParticipant.uniqueId === this.props.participant.uniqueId
    )) 
    || 
    (isIE && this.props.participant.videoStatus !== prevProp.participant.videoStatus)) {
      if (!this.props.inFullScreenV2Container) {
        this.startCall();

        // startCall() 実行後、フラグをクリア
        if (needsRtcPeerReconnect) {
          this.props.sessionActions.setWebRtcReconnectingParticipantId(null);
        }

        this.props.headerAction.updateHeaderIconClass(
          mediaType.AUDIO,
          "moduleIcon cursorDisabled",
          " cursorDisabled"
        );
        this.props.headerAction.updateHeaderIconClass(
          mediaType.AUDIO_VIDEO,
          "moduleIconActive cursorDisabled",
          " cursorDisabled"
        );  
      } else {
        this.startCallInFullScreenV2();
      }
    }

    // usecase: if any participant has started snapshot and his video was going on, the we need to remove his video element source
    if(!_.isEqual(this.props.participant, prevProp.participant) && this.props.participant.mediaType === mediaType.AUDIO 
      && prevProp.participant.mediaType === mediaType.AUDIO_VIDEO) {
      this.removeSourceOfVideo();
    }

    // this needs to be executed when video-canvas is swapped.
    // After swapping, while mounting, deviceList is not yet fetched by parent and hence comes empty.
    // since deviceList is empty, video element for SELF is not played.
    // So when parent fetches device list, the video element for SELF needs to be played.
    if((!prevProp.deviceList || !prevProp.deviceList.length) 
      && this.props.deviceList && this.props.deviceList.length >= 1 
      && this.props.uniqueId === this.props.participant.uniqueId) {
      if (!this.props.inFullScreenV2Container) {
        this.startCall();
      } else {
        this.startCallInFullScreenV2();
      }
    }

    if(!this.props.inFullScreenV2Container) {
      const ssVideo = document.getElementById(this.props.participant.uniqueId + "video");
      if ( ssVideo ) {
        if ( this.props.isFullScreenV2 && !prevProp.isFullScreenV2 ) {
          ssVideo.pause();
          console.log(`${this.props.participant.mediaType} has been paused successfully`);
        } else if ( !this.props.isFullScreenV2 && prevProp.isFullScreenV2 ) {
          ssVideo.play()
          .then(() => 
            console.log(`${this.props.participant.mediaType} has been played successfully`))
          .catch((error) => 
            console.error(`an error occurred while playing ${this.props.participant.mediaType}, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
        }
      }
    }
  }

  removeSourceOfVideo = () =>{
    // after degrading from Video to Audio need to remove src of stream from video element
    let videoElement = document.getElementById(this.props.participant.uniqueId + "video" + this.getIdSuffix());
    if(isIE){
      attachMediaStream(
        videoElement, null
      );
    } else {
      videoElement.srcObject = null;
    }
  }
  
  getAudioElement = (uniqueId) => {
    // let mediaElementToMount = document.getElementById("parent"+ this.props.participant.uniqueId);
    let videoComponent = document.getElementById("videoComponent");

    let audioElement = document.getElementById(uniqueId + "audio");
    if(!audioElement) {
      audioElement = document.createElement('audio');
      audioElement.id = uniqueId + "audio";
      audioElement.className = "elementForAudio";
      audioElement.style.visibility = "hidden";
      // mute self audio
      if(this.props.participant.uniqueId === this.props.uniqueId) {
        audioElement.volume = 0;
        audioElement.muted = true;
      } else {
        audioElement.muted = false;
        // potential fix for: WAAG-3121-Echo is observed every time at the user's end for a few seconds when the user accepts the audio/video call request.
        // autoplay should not be on for local stream 
        // Refer : https://www.slideshare.net/MuazKhan/echo-in-webrtc-why (slide 10)
        audioElement.autoplay = true;
      }
      videoComponent.appendChild(audioElement);
    }       
    return audioElement;
  }

  setWebRtcPeerOption = async (options, constraints) => {
    let virtualBackgroundFilter = null;
    if ( this.props.isVirtualBackground ) {
      virtualBackgroundFilter = this.props.getCurrentVirtualBackgroundFilter();
      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        if (stream.getVideoTracks().length !== 0) {
          const filterStream = await virtualBackgroundFilter.getFilteredStream(stream, (error) => {
            toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
            const self = this;
            setTimeout(() => self.props.hideSpinner(),1000);
            if (this.props.recoverCameraStream ) this.props.recoverCameraStream(stream);
          });
          options.videoStream = filterStream;
        }
      } catch( error ) {
        console.error(error);
        toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
        const self = this;
        setTimeout(() => self.props.hideSpinner(),1000);
      }
    }
  }

  createRTCPeerAndStartSharing = async (mediaEle, constraints, onIceCandidate, offerToReceive, participantMediaType) => {
    let self = this;
    let rtcPeer = null;
    let mediaElement = mediaEle;
    if (mediaEle && this.props.uniqueId === this.props.participant.uniqueId) {  // if user is self
      
      let rtcPeerCount = this.props.participant.mediaType === "AUDIO_VIDEO" ? 2 : 1
      
      // for first time, we need to create an RTCPeer for both audio and video 
      if (
        wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] ===
        undefined || Object.keys(wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId]).length < rtcPeerCount
      ) {
        let options = {
          localVideo: mediaElement,
          mediaConstraints: constraints,
          onicecandidate: onIceCandidate,
          configuration: {
            iceServers: getTurnServerOptionConfig(this.props.turnServer),
            iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
          }
        };
        if( participantMediaType === mediaType.VIDEO ) {
          await this.setWebRtcPeerOption(options, constraints);
        }
        console.log("createRTCPeerAndStartSharing options: ", options, "participantMediaType", participantMediaType);
  
        wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] ===
        undefined ? {} : wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId];
        this.props.clearPeerError(this.props.participant.uniqueId, participantMediaType );
        rtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(
          options,
          function(error) {
            if (error) {
              self.props.putPeerError( self.props.participant.uniqueId, participantMediaType, error );
              let errorMessage = getUserMediaError(error, participantMediaType)
              if(errorMessage){
                toastr.error(getMessage(errorMessage))
              }
              setTimeout(() => self.props.hideSpinner(),1000);
              
              return console.error(error);

            }
            setTimeout(() => self.props.hideSpinner(),1000);
            // we need to save rtcPeer Local Stream in currentStream because after switching the camera, we need to stop the current stream
            if(participantMediaType === mediaType.VIDEO) {
              console.debug(`createRTCPeerAndStartSharing() call self.props.setCurrentStream() createTime=${self.createTime} uniqueId=${self.props.uniqueId}`);
              self.props.setCurrentStream(
                wsocket.audioAndVideoRtcPeer[
                self.props.participant.uniqueId
                ][participantMediaType].getLocalStream())
            } else if(participantMediaType === mediaType.AUDIO) {
              self.props.setCurrentAudioStream(
                wsocket.audioAndVideoRtcPeer[
                self.props.participant.uniqueId
                ][participantMediaType].getLocalStream())
            }
            console.log(participantMediaType, "WEBRTC self stream id for", 
              getFirstNamebyParticipantId(self.props.participants, self.props.participant.uniqueId, true),
              self.props.participant.uniqueId,
              wsocket.audioAndVideoRtcPeer[self.props.participant.uniqueId
              ][participantMediaType].getLocalStream().id    
            );
            // call Kurento Utils function to generate offer
            this.generateOffer(offerToReceive);
          }
        );
        wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][participantMediaType] = rtcPeer;
        
        let pc = rtcPeer.peerConnection; 
        pc.onconnectionstatechange = (event) => {
          console.log(participantMediaType, "WEBRTC send only RTCPeerConnection state for", 
            getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
            this.props.participant.uniqueId,
            pc.connectionState, pc.getTransceivers());
          switch(pc.connectionState) {
            case "disconnected":
            case "failed":
            case "closed":
              console.error(participantMediaType, "WEBRTC send only RTCPeerConnection state for", 
                getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
                this.props.participant.uniqueId,
                pc.connectionState, pc.getTransceivers());
              break;
          }
        }
        pc.oniceconnectionstatechange = ev => {
          console.log(participantMediaType, "WEBRTC send only IceConnection state for", 
            getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true), 
            this.props.participant.uniqueId,
            pc.iceConnectionState);
          switch(pc.iceConnectionState) {
            case "disconnected":
            case "failed":
            case "closed":
              console.error(participantMediaType, "WEBRTC send only IceConnection state for", 
                getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true), 
                this.props.participant.uniqueId,
                pc.iceConnectionState);
              break;
          }
        }
      } else {  // control will come here when we switch primary video element to another participant's video
        if (mediaElement) {
          const playLocalStream = () => {
            if ( this.props.isPeerError(this.props.participant.uniqueId, participantMediaType) ) {
              return;
            }
            const rtcPeer = wsocket.audioAndVideoRtcPeer[ this.props.participant.uniqueId][participantMediaType];
            if (!rtcPeer) {
              return;
            }
            const pc = rtcPeer.peerConnection;
            switch (pc.connectionState) {
              case "disconnected":
              case "failed":
              case "closed":
                return;
              case "completed":
              case "connected":
                break;
              default:
                setTimeout(playLocalStream, 500);
                return;
            }

            // need to handle IE separately because we cannot attach a source to video element in IE
            if (isIE) {
              if(wsocket.audioAndVideoRtcPeer[
              this.props.participant.uniqueId
              ][participantMediaType].getLocalStream())
                attachMediaStream(
                  mediaElement,
                  wsocket.audioAndVideoRtcPeer[
                  this.props.participant.uniqueId
                  ][participantMediaType].getLocalStream()
                );
              if(this.props.currentStream) {
                attachMediaStream(
                  mediaElement,this.props.currentStream
                );
              }
            } else {
              if(wsocket.audioAndVideoRtcPeer[
              this.props.participant.uniqueId
              ][participantMediaType].getLocalStream()) {
                console.log(`createRTCPeerAndStartSharing() ${participantMediaType} set mediaElement.srcObject from audioAndVideoRtcPeer createTime=${this.createTime} uniqueId=${this.props.uniqueId}`);
                mediaElement.srcObject = wsocket.audioAndVideoRtcPeer[
                this.props.participant.uniqueId
                ][participantMediaType].getLocalStream();
                console.log(`createRTCPeerAndStartSharing() ${participantMediaType} mediaElement(audioAndVideoRtcPeer).srcObject.active=${mediaElement.srcObject && mediaElement.srcObject.active !== undefined ? mediaElement.srcObject.active : ''} from audioAndVideoRtcPeer createTime=${this.createTime} uniqueId=${this.props.uniqueId}`);
              } 
              if(this.props.currentStream) {
                console.log(`createRTCPeerAndStartSharing() ${participantMediaType} set mediaElement.srcObject from currentStream createTime=${this.createTime} uniqueId=${this.props.uniqueId}`);
                mediaElement.srcObject = this.props.currentStream
                console.log(`createRTCPeerAndStartSharing() ${participantMediaType} mediaElement(currentStream).srcObject.active=${mediaElement.srcObject && mediaElement.srcObject.active !== undefined ? mediaElement.srcObject.active : ''} from audioAndVideoRtcPeer createTime=${this.createTime} uniqueId=${this.props.uniqueId}`); 
              }
            }
            if (!this.props.inFullScreenV2Container) {
              if (!this.props.isFullScreenV2) {
                mediaElement.play()
                .then(() =>
                  console.log(`createRTCPeerAndStartSharing() ${participantMediaType} has been played successfully createTime=${this.createTime} uniqueId=${this.props.uniqueId}`))
                .catch((error) =>
                  console.error(`createRTCPeerAndStartSharing() an error occurred while playing ${participantMediaType}, error : ${error && error.message ? error.message : JSON.stringify(error)} createTime=${this.createTime} uniqueId=${this.props.uniqueId}`));
              } else  {
                mediaElement.pause();
                console.log(`createRTCPeerAndStartSharing() ${this.props.participant.mediaType} has been paused successfully`);
              }
            }

            // console.log(participantMediaType, "self stream id for", 
            //   getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true), 
            //   this.props.participant.uniqueId,
            //   wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId
            //   ][participantMediaType].getLocalStream().id    
            // );
          }
          playLocalStream();
        }
      }
    }
  };

  createRTCPeerAndStartReceiving = (mediaEle, constraints, onIceCandidate, offerToReceive, mediaType) => {
    let self = this;
    let rtcPeer = null;
    let mediaElement = mediaEle;

    var options = {
      remoteVideo: mediaElement,
      mediaConstraints: constraints,
      onicecandidate: onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    let rtcPeerCount = this.props.participant.mediaType === "AUDIO_VIDEO" ? 2 : 1;
    if (
      wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] === undefined || 
      Object.keys(wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId]).length < rtcPeerCount
    ) {
      wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] = wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId] ===
      undefined ? {} : wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId];
      this.props.clearPeerError(this.props.participant.uniqueId, mediaType );
      rtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(
        options,
        function(error) {
          if (error) {
            console.log(error);
            self.props.putPeerError( self.props.participant.uniqueId, mediaType, error );
            return console.error(error);
          }
          this.generateOffer(offerToReceive);
        }
      );
      wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType]=rtcPeer;
      let pc = rtcPeer.peerConnection; 
      pc.ontrack = (event) => {
        console.log(mediaType, "WEBRTC remote stream id for", 
          getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true), 
          this.props.participant.uniqueId,
          event.track.id    
        );
      }

      pc.onconnectionstatechange = (event) => {
        console.log(mediaType, "WEBRTC receive only RTCPeerConnection state for", 
          getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
          this.props.participant.uniqueId, pc.connectionState, pc.getTransceivers());
        
        switch(pc.connectionState) {
          case "completed":
          case "connected":
            this.playStream(mediaElement, mediaType);
            let interval = setInterval(() => {
              let participant = document.getElementById(this.props.participant.uniqueId);
              pc.getStats(null).then((stats) => {
                stats.forEach((report) => {
                  if(report.audioLevel >= 0.1) {
                    if(participant){
                      participant.classList.remove("speaking");
                      void participant.offsetWidth;
                      participant.classList.add("speaking");
                    }
                  }
                });
              });
              if(pc.connectionState == 'disconnected' ||
                pc.connectionState == 'failed' ||
                pc.connectionState == 'closed') {
                clearInterval(interval); 
              }
            }, 200);
            break;
          case "disconnected":
          case "failed":
          case "closed":
            console.error(mediaType, "WEBRTC receive only RTCPeerConnection state failed for", 
              getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
              this.props.participant.uniqueId, 
              pc.connectionState, pc.getTransceivers());
            break;
        }

      }

      pc.oniceconnectionstatechange = ev => {
        console.log(mediaType, "WEBRTC receive only IceConnection state for", 
          getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
          this.props.participant.uniqueId, pc.iceConnectionState);
        switch(pc.iceConnectionState) {
          case "disconnected":
          case "failed":
          case "closed":
            console.error(mediaType, "WEBRTC receive only IceConnection state for", 
              getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true),
              this.props.participant.uniqueId, pc.iceConnectionState);
            break;
        }
      }

    } else {
      this.playStream(mediaElement, mediaType);
    }
  };

  playStream =(mediaElement, mediaType)=> {
    if (mediaElement) {
      console.log(mediaElement, mediaType,this.props.participant.uniqueId)
      if (isIE) {
        if(this.props.participant.videoStatus !== mediaStatus.MUTED 
           && this.props.participant.videoStatus !== mediaStatus.MUTED_BY_AGENT
           || mediaType === mediaType.AUDIO) {
          attachMediaStream(
            mediaElement,
            wsocket.audioAndVideoRtcPeer[
            this.props.participant.uniqueId
            ][mediaType].getRemoteStream()
          );
        } else {  // in case of muted video / audio call, we need to pass source as null for IE
          attachMediaStream(
            mediaElement, null
          );
        }
      } else {
        mediaElement.srcObject = wsocket.audioAndVideoRtcPeer[
        this.props.participant.uniqueId
        ][mediaType].getRemoteStream();
        console.log(wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId][mediaType])
        console.log(mediaElement.srcObject)
        if (mediaType === "AUDIO" || ( !this.props.inFullScreenV2Container && !this.props.isFullScreenV2 ) ) {
          mediaElement.play()
          .then(() => 
            console.log(this.props.participant.uniqueId,`${mediaType} has been played successfully`))
          .catch((error) => 
            console.error(`${this.props.participant.uniqueId} an error occurred while playing ${mediaType}, error : ${error && error.message ? error.message : JSON.stringify(error)}`));
        } else if ( mediaType === "VIDEO" && !this.props.inFullScreenV2Container && this.props.isFullScreenV2 ) {
          mediaElement.pause();
          console.log(`${mediaType} has been paused successfully`);
        }
      }
      // console.log(mediaType, "remote stream id for", 
      //   getFirstNamebyParticipantId(this.props.participants, this.props.participant.uniqueId, true), 
      //   this.props.participant.uniqueId,
      //   wsocket.audioAndVideoRtcPeer[this.props.participant.uniqueId
      //   ][mediaType].getRemoteStream().id
      // );
    }
  }
  // call back function by Kurento utils to send ICE candidates
  onIceCandidate = (candidate, wp, media) => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.ICE_CANDIDATE,
        sessionKey: this.props.sessionKey,
        iceData: {
          candidate: candidate,
          senderId: this.props.participant.uniqueId,
          media: mediaType.VIDEO
        },
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  onIceCandidateAudio = (candidate, wp) => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.ICE_CANDIDATE,
        sessionKey: this.props.sessionKey,
        iceData: {
          candidate: candidate,
          senderId: this.props.participant.uniqueId,
          media: mediaType.AUDIO
        },
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  // this callback function is called by Kurento Utils after sdp offers get generated
  offerToReceiveVideo = (error, offerSdp, wp) => {
    if (error) return console.error("sdp offer error");
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SDP_OFFER,
        sessionKey: this.props.sessionKey,
        sdp: offerSdp,
        senderId: this.props.participant.uniqueId,
        media: mediaType.VIDEO,
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  offerToReceiveAudio = (error, offerSdp, wp) => {
    if (error) return console.error("sdp offer error");
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SDP_OFFER,
        sessionKey: this.props.sessionKey,
        sdp: offerSdp,
        senderId: this.props.participant.uniqueId,
        media: mediaType.AUDIO,
        isSnapshot: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  getAudioVideoClassName() {
    let style = (this.props.participant.videoStatus == mediaStatus.MUTED
      || this.props.participant.videoStatus == mediaStatus.MUTED_BY_AGENT)
      ? "videoHeight flipVideo videoWidth hideElement"
      : (this.props.facingMode === null || this.props.facingMode === 'user')
        ? "videoHeight flipVideo videoWidth hideElement"
        : "videoHeight videoWidth hideElement";
    style += this.props.participant.mediaType !== mediaType.AUDIO_VIDEO ?
      (this.props.participant.role == 'AGENT') ? " agentColor" : " guestColor" : "";
    return style;
  }

  getParticipantAudioVideoClassName() {
    let style = this.props.participant.uniqueId === this.props.uniqueId
      ? (this.props.participant.videoStatus === mediaStatus.MUTED
        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
        ? "videoHeight videoWidth hideElement"
        : "orangeBorder videoHeight videoWidth hideElement"
      : (this.props.participant.videoStatus === mediaStatus.MUTED
        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
        ? "videoHeight videoWidth hideElement"
        : "videoHeight videoWidth hideElement";
    style += this.props.participant.mediaType !== mediaType.AUDIO_VIDEO ?
      (this.props.participant.role == 'AGENT') ? " agentColor" : " guestColor" : "";
    return style;
  }

  componentWillUnmount() {
    if (this.props.inFullScreenV2Container) {
      if ( 0 != this.waitVideoRtcPeer ) {
        clearInterval(this.waitVideoRtcPeer);
      }
      if ( 0 != this.waitAudioRtcPeer ) {
        clearInterval(this.waitAudioRtcPeer);
      }
      if ( 0 != this.audioWatcher ) {
        clearInterval(this.audioWatcher);
      }
      return;
    }
    clearInterval(this.interval);
    console.debug(`componentWillUnmount() OUT createTime=${this.createTime} uniqueId=${this.props.uniqueId}`);
  }

  renderSnapshotCover () {
    return(
      this.props.participant.uniqueId === this.props.snapshoteeId || (this.props.isVideo && this.props.participant.mediaType === mediaType.AUDIO) ? (
        <div className="snapshot_cover">
          {getMessage("SNAPSHOT_TAKING")}
        </div>
      ) : null
    )
  }

  renderAvatar(participantName) {
    const isAgent = this.props.participant.role === USER_ROLES.AGENT ? true : false;
    return(
      <img
        title={isAgent ? participantName : USER_STATIC.GUEST}
        src={isAgent ? img_avater_agent : img_avater_user}
        className={isAgent ? "agentAvatar" : "userAvatar"}
      />
    )
  }

  render() {
    // console.log(this.props.videoBandwidthSettings)
    let videoStyleObject1 = {
      width: "auto",
      visibility: this.props.participant.mediaType === mediaType.AUDIO_VIDEO && (this.props.participant.videoStatus === mediaStatus.MUTED
        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT) ? "hidden" : "visible"// if video is muted then hide video tag
    }
    let videoStyleObject2 = {
      width: "100%",
      visibility: this.props.participant.mediaType === mediaType.AUDIO_VIDEO && (this.props.participant.videoStatus === mediaStatus.MUTED
        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT) ? "hidden" : "visible"// if video is muted then hide video tag
    }
    let participantName = this.props.participant.role === USER_ROLES.AGENT
      ? getUserNameForSelectedLanguage(this.props.language, this.props.participant.userName)
      : USER_STATIC.GUEST;

    let terminalInfo = this.props.participant.role === USER_ROLES.USER
      ? this.props.participant.terminalInfo
      : null;

    // let videoContainerClass = this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO ? "" : "";
    const showBitrate = 
      window._env_.REACT_APP_SHOW_BITRATE == "true" &&
      !isIE &&
      ( ( !this.props.isFullScreenV2 && !this.props.inFullScreenV2Container ) || 
        ( this.props.inFullScreenV2Container && this.props.inFullScreenV2Main )) ? true : false;
    const showIconsPositionBarSelf =
      ( ( !this.props.isFullScreenV2 && !this.props.inFullScreenV2Container ) || 
        ( this.props.inFullScreenV2Container && this.props.inFullScreenV2Main )) && this.isMobileOnly ? true : false;
    const showIconsPositionBarOther = !this.props.inFullScreenV2Container && this.isMobileOnly ? true : false;
    const disableSetPrimaryParticipant = 
      ( this.props.isFullScreenV2 && this.props.inFullScreenV2Container && !this.props.inFullScreenV2Main ) ? true: false;
    return (
      <div 
        id={!this.props.inFullScreenV2Container ? 
          "videoContainer" + this.props.isMainScreen
          : "videoContainer" + this.props.isMainScreen + ( this.props.isMainScreen ? "" : this.props.index ) + this.getIdSuffix()}
        className={
          !this.props.inFullScreenV2Container ? (
            this.props.index == 0
              ? (OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true" && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO) 
                ? "col-lg-12 bigVideo px-0 py-0 bgInherit slideItem"
                : "col-lg-12 px-0 py-0 bgInherit slideItem flex-0" 
              : this.props.index == 1 
                ? "smallVideo marginAuto bgInherit slideItem" 
                : this.props.totalWebRtcElement - 1 == this.props.index 
                  ? "smallVideo marginAuto px-0 py-0 bgInherit slideItem"
                  : "smallVideo marginAuto px-0 py-0 bgInherit slideItem"
          ) : (
            this.props.index == 0
              ? this.props.inFullScreenV2Main ? "col-lg-12 bgInherit" : "col-lg-12 px-0 py-0 bgInherit slideItem"
              : !this.props.inFullScreenV2Main && this.props.totalWebRtcElement - 1 == this.props.index 
                ? "smallVideo marginAuto px-0 py-0 bgInherit slideItem"
                : "smallVideo marginAuto px-0 py-0 bgInherit slideItem"
          )
        }
      >
        <div
          className={
            `${(this.props.index == 0 && !this.props.isFlimStripContainer)
              ? OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true" ?
                this.props.participant.uniqueId !== this.props.uniqueId ?
                  "audiovideo2 displayFlex IEflexNone justifyContentFlexCenter" :
                  "orangeBorder audiovideo2 displayFlex IEflexNone justifyContentFlexCenter" 
                : this.props.participant.uniqueId !== this.props.uniqueId  ?
                  "audiovideo2 displayFlex IEflexNone justifyContentFlexCenter":
                  "orangeBorder audiovideo2 displayFlex IEflexNone justifyContentFlexCenter" 
              : this.props.participant.uniqueId !== this.props.uniqueId ?
                "audiovideo6 displayFlex IEflexNone justifyContentFlexCenter" :
                "orangeBorder audiovideo6 displayFlex IEflexNone justifyContentFlexCenter"}
              ${this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO 
                && this.props.participant.uniqueId !== this.props.uniqueId ? " audiovideo2_user" : ""}
            `
          }
          onClick = {() => {
            if(this.props.setPrimaryParticipant && this.props.participant && !disableSetPrimaryParticipant) {
              this.props.setPrimaryParticipant(this.props.participant.uniqueId);
            }
          }}
          id={this.props.participant.uniqueId + this.getIdSuffix()}
          title={this.props.participant.userName}
        >
          <div className="effect-frame"></div>
          {
            showBitrate &&
              <div className={this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO && this.props.isMainScreen && !(isMobileOnly && isIOS) && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO ? "bitrate-right" : ""}>
                <BitRateTile 
                  mediaType = {
                    this.props.participant.mediaType === mediaType.AUDIO_VIDEO
                      ? "VIDEO"
                      : "AUDIO"
                  }
                  participantUniqueID = {this.props.participant.uniqueId}
                  uniqueId = {this.props.uniqueId}
                  wsocketPeer = {wsocket.audioAndVideoRtcPeer}
                />
              </div>
          }
          {this.props.participant.uniqueId === this.props.uniqueId ? (
            <div id={"parent"+ this.props.participant.uniqueId + this.getIdSuffix()} className="parentTagForIE">
              <video
                data-object-fit="contain"
                className={this.getAudioVideoClassName()}
                id={this.props.participant.uniqueId + "video" + this.getIdSuffix()}
                style={this.props.index == 0
                  ? videoStyleObject2 : videoStyleObject1}
                volume={0}
                autoPlay
                muted
                playsInline
                poster={null}
              />
              {this.props.inFullScreenV2Container && !this.props.inFullScreenV2Main ? null :
                <label className="displayFlex alignItemsCenter justifyContentFlexCenter IEAcronym labelLeft">
                  {participantName} 
                  {(this.props.participant.audioStatus === mediaStatus.MUTED
                  || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT) && this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER && (
                    <img
                      title={getMessage("MUTE_AUDIO")}
                      src={ic_mic_off}
                      className="ic_mic"
                    />
                  )}
                </label>
              }
              <div>
                { showIconsPositionBarSelf &&
                  <IconsPositionBar
                    sessionKey={this.props.sessionKey}
                    componentInFocus={this.props.componentInFocus}
                    organiser={this.props.organiser}
                    uniqueId={this.props.uniqueId}
                    participant={this.props.participant}
                    index={this.props.index}
                    onOpenCloseEndVideoCallConfirmationModal={this.props.onOpenCloseEndVideoCallConfirmationModal}
                    onOpenCloseEndAudioCallConfirmationModal={this.props.onOpenCloseEndAudioCallConfirmationModal}
                    isVideo={this.props.isVideo}
                    // showFilmStrip={this.props.showFilmStrip}
                    isFlimStripContainer={this.props.isFlimStripContainer}
                    hideButton={this.props.inFullScreenV2Container && this.props.inFullScreenV2Main ? true : false}
                  />
                }
              </div>
              {/* {this.renderSnapshotCover()} */}
              {this.renderAvatar(participantName)}
            </div>
          ) : 
            <div id={"parent"+ this.props.participant.uniqueId + this.getIdSuffix()} className="parentTagForIE">
              <video
                data-object-fit="contain"
                className={this.getParticipantAudioVideoClassName()}
                id={this.props.participant.uniqueId + "video" + this.getIdSuffix()}
                style={this.props.index == 0
                  ? videoStyleObject2 : videoStyleObject1}
                volume={0}
                autoPlay
                playsInline
                muted
                poster={null}
              />
              {this.props.participant.videoStatus === mediaStatus.MUTED
              || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT}
              {this.props.inFullScreenV2Container && !this.props.inFullScreenV2Main ? null :
                <label className="displayFlex alignItemsCenter justifyContentFlexCenter IEAcronym labelLeft">{ participantName }
                  {(this.props.participant.audioStatus === mediaStatus.MUTED
                  || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT) && this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER && (
                    <img
                      title={getMessage("MUTE_AUDIO")}
                      src={ic_mic_off}
                      className="ic_mic"
                    />
                  )}
                </label>
              }
              { this.props.organiser === this.props.uniqueId
                && terminalInfo
                && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
                && this.props.isMainScreen
                && !this.props.isFullScreen &&
                <label className="displayFlex alignItemsCenter justifyContentFlexCenter IEAcronym labelRight">
                  {terminalInfo} 
                </label>
              }
              <div>
                { showIconsPositionBarOther &&
                  <IconsPositionBar
                    sessionKey={this.props.sessionKey}
                    componentInFocus={this.props.componentInFocus}
                    organiser={this.props.organiser}
                    uniqueId={this.props.uniqueId}
                    participant={this.props.participant}
                    index={this.props.index}
                    onOpenCloseEndVideoCallConfirmationModal={this.props.onOpenCloseEndVideoCallConfirmationModal}
                    onOpenCloseEndAudioCallConfirmationModal={this.props.onOpenCloseEndAudioCallConfirmationModal}
                    isVideo={this.props.isVideo}
                    // showFilmStrip={this.props.showFilmStrip}
                    isFlimStripContainer={this.props.isFlimStripContainer}
                  />
                }
              </div>
              {/* {this.renderSnapshotCover()} */}
              {this.renderAvatar(participantName)}
            </div>
          }
        </div>
        { this.props.isMainScreen && this.props.isFullScreen &&
          (
            <div
              id={"positionIconsFullscreen"}
              className={"positionIconsFullscreen"}
            >
              <img
                title={getMessage("SCREEN_ZOOMOUT")}
                id="minimize"
                src={ic_minimize}
                style={{filter: 'invert(1)'}} // Temporary measures
                className="videoIcon cursorPointer px-md-1 px-0 m-0"
                onClick={this.props.toggleScreenZoomout}
              />
            </div>
          )
        }
      </div>
    );
  }
  static getDerivedStateFromProps(props, state) {
    if (props.isTransform !== state.isTransform) {
      state.isTransform = props.isTransform;
      let id = props.uniqueId + "video";
      let targetVideo = document.getElementById(id);
      if(targetVideo){
        if (props.isTransform) {
          targetVideo.style.transform = "scale(1)";
        } else {
          targetVideo.style.transform = "";
        }
      }
    }
    return null
  }
}
